export default __webpack_public_path__ + "static/media/int_gs.0c353931.svg";